import { getLibraryAssetKey } from "../../libraryCatalog";
import { resolveCritterAssetsUrl } from "../../assetPaths";
import {
  cubeAsset,
  eggAsset,
  pandaAsset,
  robotiq2f85Asset,
  shadowHandAsset,
  spotArmPresetAsset,
  trossenAsset,
  trayAsset,
  ur5eAsset,
} from "../libraryAssets";

export const manipulationRecipeUiMetadata = {
  pick_and_place_ur5e: {
    groupId: "manipulation",
    groupLabel: "Manipulation",
    scenarioId: "pick_and_place",
    scenarioLabel: "Pick and Place",
    robotId: "ur5e",
    robotLabel: "UR5e",
    thumbnailPath: resolveCritterAssetsUrl("/robots/ur5e/thumbnail-pick-and-place.png"),
  },
  pick_and_place_panda: {
    groupId: "manipulation",
    groupLabel: "Manipulation",
    scenarioId: "pick_and_place",
    scenarioLabel: "Pick and Place",
    robotId: "franka_emika_panda",
    robotLabel: "Panda",
    thumbnailPath: resolveCritterAssetsUrl(
      "/robots/franka_emika_panda/thumbnail-pick-and-place.png"
    ),
  },
  pick_and_place_trossen: {
    groupId: "manipulation",
    groupLabel: "Manipulation",
    scenarioId: "pick_and_place",
    scenarioLabel: "Pick and Place",
    robotId: "trossen_wx250s",
    robotLabel: "Trossen",
    thumbnailPath: resolveCritterAssetsUrl("/robots/trossen_wx250s/thumbnail-pick-and-place.png"),
  },
  pick_and_place_spot_arm: {
    groupId: "manipulation",
    groupLabel: "Manipulation",
    scenarioId: "pick_and_place",
    scenarioLabel: "Pick and Place",
    robotId: "boston_dynamics_spot",
    robotLabel: "Spot (+ arm)",
    thumbnailPath: resolveCritterAssetsUrl(
      "/robots/boston_dynamics_spot/thumbnail-pick-and-place.png"
    ),
  },
  pick_and_place_spot_arm_no_tray: {
    groupId: "manipulation",
    groupLabel: "Manipulation",
    scenarioId: "pick_and_place",
    scenarioLabel: "Pick and Place",
    robotId: "boston_dynamics_spot",
    robotLabel: "Spot",
    thumbnailPath: resolveCritterAssetsUrl(
      "/robots/boston_dynamics_spot/thumbnail-pick-and-place.png"
    ),
  },
  shadow_hand_egg: {
    groupId: "manipulation",
    groupLabel: "Manipulation",
    scenarioId: "shadow_hand_egg",
    scenarioLabel: "Shadow Hand Egg",
    robotLabel: "Shadow Hand",
    thumbnailPath: resolveCritterAssetsUrl("/attachments/shadow_hand/thumbnail-egg.png"),
  },
};

export const manipulationRecipes = [
  {
    id: "pick_and_place_ur5e",
    label: "Pick and Place (UR5e)",
    kind: "libraryRecipe",
    cameraPreset: "ur5ePickAndPlace",
    steps: [
      {
        assetKey: getLibraryAssetKey(ur5eAsset),
        applyKeyframe: "home",
      },
      {
        assetKey: getLibraryAssetKey(robotiq2f85Asset),
      },
      {
        assetKey: getLibraryAssetKey(trayAsset),
        transform: { position: [-0.6, 0.0, 0.0] },
      },
      {
        assetKey: getLibraryAssetKey(cubeAsset),
        transform: { position: [-0.6, -0.276, 0.03] },
      },
    ],
  },
  {
    id: "pick_and_place_panda",
    label: "Pick and Place (Panda)",
    kind: "libraryRecipe",
    steps: [
      {
        assetKey: getLibraryAssetKey(pandaAsset),
        applyKeyframe: "home",
      },
      {
        assetKey: getLibraryAssetKey(trayAsset),
        transform: { position: [0.5393939208984375, -0.2290909423828125, 0.0015151367187500482] },
      },
      {
        assetKey: getLibraryAssetKey(cubeAsset),
        transform: { position: [0.5903031005859375, -1.654568409364954e-17, 0.02548486328125] },
      },
    ],
  },
  {
    id: "pick_and_place_trossen",
    label: "Pick and Place (Trossen)",
    kind: "libraryRecipe",
    cameraPreset: "trossenPickAndPlace",
    steps: [
      {
        assetKey: getLibraryAssetKey(trossenAsset),
        applyKeyframe: "home",
      },
      {
        assetKey: getLibraryAssetKey(trayAsset),
        transform: { position: [0.28, -0.149, 0.002] },
      },
      {
        assetKey: getLibraryAssetKey(cubeAsset),
        transform: { position: [0.275, 0.129, 0.025] },
      },
    ],
  },
  {
    id: "pick_and_place_spot_arm",
    label: "Pick and Place (Spot + arm)",
    kind: "libraryRecipe",
    steps: [
      {
        libraryAsset: spotArmPresetAsset,
        applyKeyframe: "home",
      },
      {
        assetKey: getLibraryAssetKey(trayAsset),
        // Stored pose is MuJoCo world; UI "Global" is viewer [x,z,-y] -> mj [vx, -vz, vy].
        transform: { position: [0.811, 0.128, 0.03] },
      },
      {
        assetKey: getLibraryAssetKey(cubeAsset),
        transform: { position: [0.812, -0.12, 0.03] },
      },
    ],
  },
  {
    id: "pick_and_place_spot_arm_no_tray",
    label: "Pick and Place (Spot, no tray)",
    kind: "libraryRecipe",
    /** Onboarding load only; omit from Object Library preset list. */
    hideFromAssetLibrary: true,
    steps: [
      {
        libraryAsset: spotArmPresetAsset,
        applyKeyframe: "home",
      },
      {
        assetKey: getLibraryAssetKey(cubeAsset),
        transform: { position: [0.812, -0.12, 0.03] },
      },
    ],
  },
  {
    id: "shadow_hand_egg",
    label: "Shadow Hand + Egg",
    kind: "libraryRecipe",
    steps: [
      {
        assetKey: getLibraryAssetKey(shadowHandAsset),
        applyKeyframe: "open hand",
      },
      {
        assetKey: getLibraryAssetKey(eggAsset),
        transform: {
          position: [0.309034258, 0.001, 0.118657597],
          // Euler (0, 90, 0) degrees as quaternion [w, x, y, z].
          orientation: [0.70710678, 0.0, 0.70710678, 0.0],
        },
      },
    ],
  },
];
